<template>
  <input
    type="range"
    :min="min"
    :max="max"
    :value="modelValue"
    :steps="steps"
    class="input-range input-range__vertical"
    :class="hasColors"
    @input="updateValue($event.target.value)"
    @mousedown="hoverText($event.target.value)"
    @mouseup="hoverText($event.target.value, true)"
  >
</template>

<script>
export default {
  name: 'InputRange',
  props: {
    modelValue: {
      type: Number,
      required: true,
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 1,
    },
    steps: {
      type: Number,
      default: 1,
    },
    colors: {
      type: Object,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  computed: {
    hasColors() {
      return `input-range__${this.colors[this.modelValue]}`;
    },
  },
  methods: {
    updateValue(value) {
      this.hoverText(this.modelValue, true);
      this.$emit('update:modelValue', +value);
      this.hoverText(+value);
    },
    hoverText(value, remove = false) {
      const div = this.getHoverElement(value);
      if (remove) {
        div.classList.remove('slider-choice__hover');
        return;
      }
      div.classList.add('slider-choice__hover');
    },
    getHoverElement(value) {
      let element = null;
      document.querySelectorAll('.askfeedback-slider__choices').forEach((el) => {
        if (el.offsetParent !== null) {
          element = el;
        }
      });
      const elementsRevert = [ ...element.children ].reverse();
      return elementsRevert[value];
    },
  },

};
</script>
